import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { UserDto } from './user.dto';

/**
 * Response of the composite user routes: the user with roles and regions
 * joined, plus the two flags the admin used to derive with follow-up reads.
 */
export class UserFullDto extends UserDto {
  @ApiProperty({
    description: 'True when one of the roles is Supervisor.',
  })
  @Expose()
  isSupervisor!: boolean;
}
